import React from 'react';
import {
  activityTypes,
  courseSectionTypeEnum,
  statusEnum
} from '../../../../../helper/constants.helper';
import { Button } from '@mui/material';

const CourseButtons = ({ historyItem, handleClick }) => {
  return (
    <>
      {historyItem.type === activityTypes.COURSE && historyItem.status === statusEnum.COMPLETED && (
        <Button
          variant="contained"
          color="primary"
          onClick={handleClick}
          fullWidth
          size="small"
          style={{
            display: `${historyItem.type === activityTypes.MEETING ? 'none' : 'flex'}`,
            maxHeight: '50px'
          }}>
          View Certificate
        </Button>
      )}
      {historyItem.type === activityTypes.COURSE && historyItem.status === statusEnum.INITIATED && (
        <Button
          variant="contained"
          color="primary"
          onClick={handleClick}
          fullWidth
          size="small"
          style={{
            display: `${historyItem.type === activityTypes.MEETING ? 'none' : 'flex'}`,
            maxHeight: '50px'
          }}>
          Continue course
        </Button>
      )}
      {historyItem.type === activityTypes.COURSE &&
        historyItem?.sections
          ?.filter(
            (section) => section.type === courseSectionTypeEnum.ACTIVITY && section.assignment_url
          )
          .map((section, index) => (
            <Button
              key={section.id}
              size="small"
              target="_blank"
              fullWidth
              style={{
                justifyContent: 'flex-start',
                textAlign: 'left'
              }}
              href={section.assignment_url}>
              View assignment {index + 1}
            </Button>
          ))}

      {historyItem.type === activityTypes.COURSE &&
        historyItem?.sections
          ?.filter(
            (section) => section.type === courseSectionTypeEnum.ASSESSMENT && section.report_url
          )
          .map((section, index) => (
            <Button
              key={section.id}
              size="small"
              target="_blank"
              fullWidth
              style={{
                justifyContent: 'flex-start',
                textAlign: 'left'
              }}
              href={section.report_url}>
              View report
            </Button>
          ))}
    </>
  );
};

export default CourseButtons;
